import React from 'react'
import { useDispatch } from 'react-redux'
import { toggleShowAnswers } from '../../../redux/slices/preview'

export default function ShowAnswers({ showAnswers }) {

    const dispatch = useDispatch()

    const handleClick = () => {
        dispatch(toggleShowAnswers())
    }
    return (
        <div className='show_answers' id={showAnswers ? 'active' : ''} onClick={handleClick} >
            {showAnswers ?
                <img src='/assets/icons/eye-icon-hidden.svg' /> :
                <img src='/assets/icons/showPassword.svg' /> 
                }
                  {showAnswers ? 'Hide Answers' :  'Show Answers' }
        </div>
    )
}
